import React from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate } from "react-router";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Create } from "@refinedev/mui";

import { ReferralForm } from "@modules/partners/components";
import { useReferralCreateForm } from "./controller";

const REFERRALS_LIST_PATH = "/partners?tab=referrals";

export const ReferralCreate = React.memo(() => {
  const navigate = useNavigate();
  const { methods, handleSubmit, mutateAsync, isPending } = useReferralCreateForm();

  return (
    <Create
      resource="v1/partner_referral_admin"
      goBack={
        <IconButton onClick={() => navigate(REFERRALS_LIST_PATH)}>
          <ArrowBackIcon />
        </IconButton>
      }
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <ReferralForm />
      </FormProvider>
    </Create>
  );
});
